<template>
  <ion-skeleton-text
    :animated="true"
    :style="`width: 100%; aspect-ratio: 696/471`"
  />
</template>
